import React from "react"
import Layout from "../components/layout"
import Privacy from "../components/privacy"

const PrivacyPageJa = () => {
  return (
    <Layout>
      <Privacy title="プライバシーポリシー">
        <ul>
          <li>
            『広告IDの利用』
            <ul>
              <li>
                広告を表示する際に、固有のIDが利用されています。アプリから送信されるデータという点で、利用することをここに明記しています。この情報から個人が特定されることはありません。
              </li>
            </ul>
          </li>
          <li>
            ネットワークアクセス
            <ul>
              <li>アプリ内への広告表示に利用されています。</li>
            </ul>
          </li>
          <li>上記のほか、個人情報は利用されません。</li>
        </ul>
      </Privacy>
    </Layout>
  )
}

export default PrivacyPageJa
